import styled from 'styled-components';

export const StyledCard = styled.div`
  border: 1px solid #eee;
  padding: 16px;
  margin-bottom: 16px;

  h3 {
    text-align: center;
  }
`;
